import Image from "common/components/Image";
import {
  BotAvatar,
  BotDescription,
  BotTitle,
} from "../StyledContainer/StyledContainer";
import Icon from "react-icons-kit";
import { arrowRight } from "react-icons-kit/feather/arrowRight";
import useGetLangageContext from "common/hooks/useGetLangageContext";

const BotContent = ({ item, displayArrow }) => {
  const { langageContext } = useGetLangageContext();
  return (
    <>
      <BotAvatar>
        <Image
          src={
            item.user?.profilePicture
              ? item.user?.profilePicture
              : "https://previews.123rf.com/images/redlinevector/redlinevector2001/redlinevector200101077/137477582-ic%C3%B4ne-de-fine-ligne-de-profil-de-robot-bot-chat-bot-signe-de-contour-isol%C3%A9-d-aide-en-ligne.jpg"
          }
          style={{ width: "64px", height: "64px" }}
        />
      </BotAvatar>
      <div style={{ paddingLeft: "8px", width: "80%", marginTop: "8px" }}>
        <BotTitle>
          {item.name}{" "}
          <Icon
            style={{ marginLeft: 10 }}
            className="arrow-icon"
            icon={arrowRight}
          />
        </BotTitle>
        <BotDescription>{langageContext?.locale === "fr-fr" ? item.descriptionFR : item.description}</BotDescription>
      </div>
    </>
  );
};
export default BotContent;
